import { useEffect } from 'react'
import { initializeAdminApiSecurity } from '@crm-src/lib/admin-api-guard'

export function AdminSecurityInitializer() {
  useEffect(() => {
    // Initialize admin API security on client side
    initializeAdminApiSecurity()
  }, [])

  // This component doesn't render anything
  return null
}


